/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserBackgroundImageContainer_user$ref: FragmentReference;
export type UserBackgroundImageContainer_user = {|
  +id: string,
  +backgroundOption: ?string,
  +customImage: ?string,
  +backgroundColor: ?string,
  +backgroundImage: ?{|
    +imageURL: ?string,
    +timestamp: ?string,
  |},
  +$refType: UserBackgroundImageContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "UserBackgroundImageContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "backgroundOption",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "customImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "backgroundColor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "backgroundImage",
      "storageKey": null,
      "args": null,
      "concreteType": "BackgroundImage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageURL",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "timestamp",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '145a4f533fcf42c7355d51459702c96d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/User/__generated__/UserBackgroundImageContainer_user.graphql.js